import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SaleService } from '../../../services/sale.service';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonModule } from '@angular/common';
import { FieldsetModule } from 'primeng/fieldset';
import { ListProdutInSaleFormComponent } from '../list-produt-in-sale-form/list-produt-in-sale-form.component';
import { Sale } from '../../../models/sale.model';

@Component({
  selector: 'app-form-sale',
  imports: [
    ButtonModule,
    TabsModule,
    FormsModule,
    InputTextModule,
    InputNumberModule,
    CommonModule,
    FieldsetModule,
    ListProdutInSaleFormComponent
  ],
  templateUrl: './form-sale.component.html',
})
export class FormSaleComponent {

sale: Sale = {} as Sale;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private saleService: SaleService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.saleService.getById(+id).subscribe({
        next: (data) => {
          this.sale = data;

          console.log(this.sale.discount);
        },
        error: (error) => {
          console.error(error);
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/app/sales']);
  }

}
